import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  if (
    !document.querySelector(".tab-slide") ||
    !document.querySelector(".swiper.tab-carousel")
  )
    return;

  const navSlides = document.querySelectorAll(".tab-slide");

  const mainSwiper = new Swiper(".swiper.tab-carousel", {
    modules: [Autoplay, EffectFade],
    slidesPerView: 1,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    on: {
      slideChange(swiper) {
        updateNav(swiper.realIndex);
      },
      autoplayTimeLeft(swiper, time, progress) {
        const active = navSlides[swiper.realIndex];
        // Set height as percentage for --progress-height (e.g. 50%)
        active.style.setProperty(
          "--progress-height",
          `${(1 - progress) * 100}%`
        );
      },
    },
  });

  // Click nav to change main slide
  navSlides.forEach((slide, i) => {
    slide.addEventListener("click", () => {
      mainSwiper.slideTo(i);
    });
  });

  // Highlight current nav
  function updateNav(index) {
    navSlides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
      slide.style.setProperty("--progress-height", "0");
    });
  }

  updateNav(0); // Set initial
});
